import { compress, decompress } from 'lz-string'

// This object will be used in place of localStorage.
// It compresses all data before writing to actual localStorage,
// gaining about a factor of 7 in space efficiency

export const useCompressedLocalStorage = () => {
  // upon load, read and decompress all of localStorage into in-memory copy
  function readFromLocalStorage() {
    for (let key in global.localStorage) {
      if (global.localStorage.hasOwnProperty(key)) {
        storage[key] = decompress(global.localStorage[key])
      }
    }
    // if this gets cleared, it means that the user forcibly cleared localStorage in DevTools
    global.localStorage['markerToProveLocalStorageNotCleared'] = 'true'
  }

  // upon unload, compress and write all of in-memory copy to the real localStorage
  function saveToLocalStorage() {
    if (realLocalStorage.hasOwnProperty('markerToProveLocalStorageNotCleared')) {
      for (let key in storage) {
        if (storage.hasOwnProperty(key)) {
          realLocalStorage[key] = compress(storage[key])
        }
      }
    }
  }

  // keep a reference to the real localStorage (we'll write to it upon unload)

  const realLocalStorage = global.localStorage

  let storage = {}

  readFromLocalStorage()
  window.addEventListener("beforeunload", saveToLocalStorage);

  const inMemoryStorage = {
    getItem: function (key) {
      return storage[key] || null
    },
    setItem: function (key, value) {
      storage[key] = value ? value.toString() : ''
    },
    removeItem: function (key) {
      delete storage[key]
    },
    clear: function () {
      storage = {}
      // clear the real localStorage also so that if people use Chrome console
      // to "localStorage.clear()", it applies to the real localStorage also
      realLocalStorage.clear()
    }
  }

  Object.defineProperty(window, 'localStorage', {
    value: inMemoryStorage
  })
}
